<template>
    <div class="login-page">
         <div class="form">
            <div class="login-form">
            <input type="text" placeholder="Email" v-model="email"/>
            <input type="password" placeholder="Mot de passe" v-model="password"/>
            <button @click="login">login</button>
            <!-- <p class="message">Not registered? <a href="#">Create an account</a></p> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations,mapActions } from "vuex"
import { loginUser, logoutUser,isLoggedIn, whoami } from '../../utils/auth'
// import Input from "./Input";

export default {
    name: 'login',

    data(){
        return {
            email:'',
            password:'',
            token:'',
			project_id:-1
        }
    },
	created(){
      
    },
	mounted() {
		if(Object.keys(this.$route.query).length > 0){
			localStorage.clear()
			if(this.$route.query.redirect != undefined) {
				const url = new URL(`https://pro.immo-wiin.com/user/login${this.$route.query.redirect}`);

				// Access the query parameters using url.searchParams
				let userId = url.searchParams.get('a');
				let clientFullname = url.searchParams.get('d');
				let token = url.searchParams.get('tk');
				let tkimmo = url.searchParams.get('tkimmo');
				let project_id = url.searchParams.get('pid');
				let EmpEmail = url.searchParams.get('eemp');
				let EmpPhone = url.searchParams.get('eph');
				let CurrentIndexProjet = url.searchParams.get('cpi');

				let type = null;

				if(url.searchParams.get('type') != undefined){
					type = url.searchParams.get('type')
				}

				this.project_id = project_id
				this.token = token
				
				localStorage.setItem("userId",userId)
				localStorage.setItem("clientFullname",clientFullname)
				localStorage.setItem("EmpEmail",EmpEmail)
				localStorage.setItem("EmpPhone",EmpPhone)
				localStorage.setItem("EmpToken",this.token)
				localStorage.setItem("CurrentIndexProjet", CurrentIndexProjet)
				if(tkimmo) {
					localStorage.setItem('authToken', tkimmo)
					localStorage.setItem("project_id", this.project_id)
					this.handleExternalLogin(type)
				}
			}else {
				let userId = this.$route.query.a
				let clientFullname = this.$route.query.d
				let tkimmo = this.$route.query.tkimmo
				let project_id = this.$route.query.pid
				let EmpEmail = this.$route.query.eemp
				let EmpPhone = this.$route.query.eph
				let token = this.$route.query.tk
				let CurrentIndexProjet = this.$route.query.cpi
				
				this.token = token
				this.project_id = project_id

				let type = null;

				if(this.$route.query.type != undefined){
					type = this.$route.query.type
				}
				
				localStorage.setItem("userId",userId)
				localStorage.setItem("clientFullname",clientFullname)
				localStorage.setItem("EmpEmail",EmpEmail)
				localStorage.setItem("EmpPhone",EmpPhone)
				localStorage.setItem("EmpToken",this.token)
				localStorage.setItem("CurrentIndexProjet", CurrentIndexProjet)
				if(tkimmo) {
					localStorage.setItem('authToken', tkimmo)
					localStorage.setItem("project_id", this.project_id)
					this.handleExternalLogin(type)
				}
			}
		}else {
			localStorage.clear()
		}
	},

	

    methods: {
		...mapActions(["whoami","getUserEmails","getProjectCosts"]),

        async login() {
			this.$loading(true)
            try {
                await loginUser(this.email, this.password)

				localStorage.setItem("project_id", this.project_id)

				this.getUserEmails({id: '1122'}).then(() => {
					if(this.$route.query.type!=undefined){
						this.$loading(false);
						this.getProjectCosts({project_id: this.project_id}).then(() => {
							this.$router.push('/Comparateur-ancien')
						})
					}else{
						this.$loading(false);
						this.project_id = -1;
						localStorage.setItem("project_id", this.project_id)
						this.$router.push('/Comparateur-ancien')
					}
				})
    
            }
            catch (err) {
				this.$loading(false);
                alert(`Error: ${err}`)
            }
        },

		async handleExternalLogin(type) {
			this.$loading(true)
			try {
				await whoami()
				this.getUserEmails({id: '1122'}).then(() => {
					if(type!=null){
						this.$loading(false);
						// this.getProjectCosts({project_id: this.project_id}).then(() => {
							this.$router.push('/Comparateur-ancien')
						// })
					}else{
						this.$loading(false);
						this.$router.push('/Comparateur')
					}
				})
			}
			catch (err) {
				this.$loading(false);
                alert(`Error: ${err}`)
            }
		},

		decryptPassword(param) {
			var res = param.split(",");
			var decrypt =""
			for(var i=0; i<res.length; i++) {
				decrypt += String.fromCharCode(1990 - parseInt(res[i]))
			}
			return decrypt
		}
		
    },
    components: {
        // Input
    },

	computed: {
		...mapGetters(["CurrentUser","RolesCurrentUser"]),
	}
}
</script>

<style scoped lang="scss">
    .input-group {
        margin: 1rem;
    }

    .input-group label {
        margin-right: 0.5rem;
    }
    .btn {
      //margin-top: 15px;
      background-color: #ff8c00;
      color: white;
      border: 1px solid #ff8c00;
      border-radius: 3px;
      font-size:13px;
      width: 180px;
      &:focus {
        outline: 0;
      }
      &:hover {
        border-color: #068596ba;
        background-color: #068596fa;
      }
    }


	.login-page {
		width: 360px;
		padding: 8% 0 0;
		margin: auto;
	}
	.form {
		position: relative;
		z-index: 1;
		background: #FFFFFF;
		max-width: 360px;
		margin: 0 auto 100px;
		padding: 45px;
		text-align: center;
		box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
		input {
			font-family: "Roboto", sans-serif;
			outline: 0;
			background: #f2f2f2;
			width: 100%;
			border: 0;
			margin: 0 0 15px;
			padding: 15px;
			box-sizing: border-box;
			font-size: 14px;
		}
		button {
			font-family: "Roboto", sans-serif;
			text-transform: uppercase;
			outline: 0;
			background: #068596ba;
			width: 100%;
			border: 0;
			padding: 15px;
			color: #FFFFFF;
			font-size: 14px;
			-webkit-transition: all 0.3 ease;
			transition: all 0.3 ease;
			cursor: pointer;
			&:hover {
				background: #ff8c00;
			}
			&:active {
				background: #ff8c00;
			}
			&:focus {
				background: #ff8c00;
			}
		}
		.message {
			margin: 15px 0 0;
			color: #b3b3b3;
			font-size: 12px;
			a {
				color: #4CAF50;
				text-decoration: none;
			}
		}
		.register-form {
			display: none;
		}
	}
	.container {
		position: relative;
		z-index: 1;
		max-width: 300px;
		margin: 0 auto;
		&:before {
			content: "";
			display: block;
			clear: both;
		}
		&:after {
			content: "";
			display: block;
			clear: both;
		}
		.info {
			margin: 50px auto;
			text-align: center;
			h1 {
				margin: 0 0 15px;
				padding: 0;
				font-size: 36px;
				font-weight: 300;
				color: #1a1a1a;
			}
			span {
				color: #4d4d4d;
				font-size: 12px;
				a {
					color: #000000;
					text-decoration: none;
				}
				.fa {
					color: #EF3B3A;
				}
			}
		}
	}
	body {
		background: #76b852;
		background: -webkit-linear-gradient(right, #76b852, #8DC26F);
		background: -moz-linear-gradient(right, #76b852, #8DC26F);
		background: -o-linear-gradient(right, #76b852, #8DC26F);
		background: linear-gradient(to left, #76b852, #8DC26F);
		font-family: "Roboto", sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

</style>